import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    fetchChartData,
    fetchChartDataWithSearchApi,
    switchMainTab,
    fetchRecommendationLists,
    cleanupData,
} from "../../../../actions/insightsRecommendationActions";
// import { ReactComponent as BackArrowIcon } from "../../../../assets/svg/arrow.svg";
import { ReactComponent as ArrowIcon } from "../../../../assets/svg/chevron.svg";
import moment from "moment";
import TopInfluencers from "./TopInfluencers";
import Scrollbars from "react-custom-scrollbars";
import OCRWordcloud from "./OCRWordcloud";
import TopTopics from "./TopTopics";
import OverallSummary from "./OverallSummary";
import BrandComparision from "./BrandComparision";
import PlatformSummary from "./PlatformSummary";
import { ProductAttributes } from "../../Dashboard/ProductAttributeValues";
import ProductAttributesChart from "./ProductAttributes";
// import Help from "../HomePage/Help";
import EmptyPage from "../HomePage/EmptyPage";
import { QuestionLists } from "../HomePage/Header/InsightsTabComponent";

const ChartPageContainer = () => {
    const [notConfigured, setNotConfigured] = useState(false);

    const dispatch = useDispatch();
    const pageHeading = useSelector((state) => state.insightsRecommendationReducer.currentPage);
    const brandTopicObj = useSelector((state) => state.insightsRecommendationReducer.ownBrand);
    const competitorTopicObj = useSelector((state) => state.insightsRecommendationReducer.competitorsBrand);
    //imported from DashwidgetContainer-->arrangeFilters
    // const platforms = useSelector((state) => state.filterSettingReducer.platformsActive);
    // const countries = useSelector((state) => state.filterSettingReducer.locationsActive);
    // const languages = useSelector((state) => state.filterSettingReducer.languagesActive);
    const topicsObject = useSelector((state) => state.filterSettingReducer.topicsObject);
    const brandFilters = useSelector((state) => state.insightsRecommendationReducer.ownBrandFilters);
    const competitorFilters = useSelector((state) => state.insightsRecommendationReducer.competitorsBrandFilters);

    useEffect(() => {
        let notConfigured = !brandTopicObj && !competitorTopicObj;
        if (["overall-summary", "platform-summary"].includes(pageHeading) && !brandTopicObj) notConfigured = true;
        if (pageHeading === "brand-comparision" && (!brandTopicObj || !competitorTopicObj)) notConfigured = true;
        setNotConfigured(notConfigured);
        if (!notConfigured) fetchData();
    }, [pageHeading, competitorTopicObj, brandTopicObj]);

    const handleClick = () => {
        dispatch(switchMainTab("home"));
        dispatch(cleanupData());
    };

    const componentObj = {
        "overall-summary": OverallSummary,
        "platform-summary": PlatformSummary,
        "brand-comparision": BrandComparision,
        dynamic: TopInfluencers,
        ocr: OCRWordcloud,
        "top-topics": TopTopics,
        "product-attributes": ProductAttributesChart,
        // help: Help,
    };

    const fetchData = () => {
        switch (pageHeading) {
            case "dynamic": {
                if (brandTopicObj) {
                    let params1 = getSearchParams({ topic_data: brandTopicObj, filter: brandFilters });
                    params1.topic_name = "own";
                    params1.chart_name = "top-influencers";
                    dispatch(fetchChartData(params1));
                }

                if (competitorTopicObj) {
                    let params = getSearchParams({ topic_data: competitorTopicObj, filter: competitorFilters });
                    params.topic_name = "competitor";
                    params.chart_name = "top-influencers";
                    dispatch(fetchChartData(params));
                }
                break;
            }
            case "ocr": {
                if (brandTopicObj) {
                    let params1 = getSearchParams({ topic_data: brandTopicObj, filter: brandFilters });
                    params1.topic_name = "own";
                    params1.chart_name = "ocrWordcloud";
                    params1.aggs = "ocr-frequency-wordcloud";
                    params1.size = 100;
                    dispatch(fetchChartDataWithSearchApi(params1));
                }

                if (competitorTopicObj) {
                    let params = getSearchParams({ topic_data: competitorTopicObj, filter: competitorFilters });
                    params.topic_name = "competitor";
                    params.chart_name = "ocrWordcloud";
                    params.aggs = "ocr-frequency-wordcloud";
                    params.size = 100;

                    dispatch(fetchChartDataWithSearchApi(params));
                }
                break;
            }
            case "top-topics": {
                if (brandTopicObj) {
                    let params1 = getSearchParams({ topic_data: brandTopicObj, filter: brandFilters });
                    params1.topic_name = "own";
                    params1.chart_name = "top-topics";
                    params1.aggs = "clustering";
                    // params1.clustering_sort_by = "volume";
                    params1.image_analytics_types = [];
                    dispatch(fetchChartDataWithSearchApi(params1));
                }

                if (competitorTopicObj) {
                    let params = getSearchParams({ topic_data: competitorTopicObj, filter: competitorFilters });
                    params.topic_name = "competitor";
                    params.chart_name = "top-topics";
                    params.aggs = "clustering";
                    // params.clustering_sort_by = "volume";
                    params.image_analytics_types = [];
                    dispatch(fetchChartDataWithSearchApi(params));
                }
                break;
            }
            case "product-attributes": {
                if (brandTopicObj) {
                    let params1 = getSearchParams({ topic_data: brandTopicObj, filter: brandFilters });
                    params1.topic_name = "own";
                    params1.chart_name = "product-attributes";
                    params1.aggs = "channel-analysis-by-product-attribute-category-sov";
                    params1.product_attribute_categories = Object.keys(ProductAttributes.data).map((val) => ProductAttributes.data[val].categoryName);
                    // params1.clustering_sort_by = "volume";
                    params1.image_analytics_types = [];
                    params1["aggs-interval"] = "day";
                    params1.topicsObject = topicsObject;

                    dispatch(fetchChartDataWithSearchApi(params1));
                }

                if (competitorTopicObj) {
                    let params = getSearchParams({ topic_data: competitorTopicObj, filter: competitorFilters });
                    params.topic_name = "competitor";
                    params.chart_name = "product-attributes";
                    params.aggs = "channel-analysis-by-product-attribute-category-sov";
                    params.product_attribute_categories = Object.keys(ProductAttributes.data).map((val) => ProductAttributes.data[val].categoryName);
                    // params.clustering_sort_by = "volume";
                    params.image_analytics_types = [];
                    params["aggs-interval"] = "day";
                    params.topicsObject = topicsObject;

                    dispatch(fetchChartDataWithSearchApi(params));
                }
                break;
            }

            case "overall-summary": {
                if (brandTopicObj) {
                    let params1 = getSearchParams({ topic_data: brandTopicObj, filter: brandFilters });
                    params1.image_analytics_types = [];
                    params1["aggs-interval"] = "day";
                    params1.aggs = "conversation-over-time-sentiment";
                    params1.topic_name = "own";
                    params1.chart_name = "overall-summary";
                    params1.image_analytics_types = [];

                    dispatch(fetchChartDataWithSearchApi(params1));

                    let param = {
                        filter: {
                            own: {},
                        },
                    };
                    param.filter.own = JSON.parse(JSON.stringify(params1));
                    param.topic_name = "own";
                    param.chart_name = "overall-summary";
                    param["recommendation_types"] = ["overall_summary"];
                    dispatch(fetchRecommendationLists(param, "overall_summary", 0));
                }

                // if (competitorTopicObj) {
                //     let params = getSearchParams({ topic_data: competitorTopicObj });

                //     params.image_analytics_types = [];
                //     let param = {
                //         filter: {
                //             competitor: {},
                //         },
                //     };
                //     param.filter.competitor = JSON.parse(JSON.stringify(params));
                //     param.topic_name = "competitor";
                //     param.chart_name = "overall-summary";
                //     param["recommendation_types"] = ["overall_summary"];
                //     dispatch(fetchChartDataWithRecommendationApi(param));
                // }
                break;
            }
            case "platform-summary": {
                if (brandTopicObj) {
                    let params1 = getSearchParams({ topic_data: brandTopicObj, filter: brandFilters });
                    // params1.aggs = "channel-analysis";
                    params1.aggs = "channel-analysis-by-impact_value";
                    params1.topic_name = "own";
                    params1.chart_name = "platform-summary";
                    params1.image_analytics_types = [];
                    dispatch(fetchChartDataWithSearchApi(params1));

                    let param = {
                        filter: {
                            own: {},
                        },
                    };
                    param.filter.own = JSON.parse(JSON.stringify(params1));
                    param.topic_name = "own";
                    param.chart_name = "platform-summary";
                    param["recommendation_types"] = ["platform_summary"];
                    dispatch(fetchRecommendationLists(param, "platform_summary", 0));
                }

                break;
            }
            case "brand-comparision": {
                let paramSearch = {};

                let paramsSearch1 = getSearchParams({ topic_data: brandTopicObj, filter: brandFilters });
                let paramsSearch2 = getSearchParams({ topic_data: competitorTopicObj, filter: competitorFilters });
                Object.keys(paramsSearch1).forEach((ele) => {
                    if (ele === "topic_data") paramsSearch2[ele] = [...paramsSearch2[ele], ...paramsSearch1[ele]];
                });

                paramSearch = JSON.parse(JSON.stringify(paramsSearch2));
                paramSearch.image_analytics_types = [];
                paramSearch["aggs-interval"] = "day";
                // paramSearch.aggs = "engagement_datewise_breakdown_with_exclusion";
                paramSearch.aggs = "volume-of-conversation";
                paramSearch.topic_name = "own";
                paramSearch.chart_name = "brand-comparision";
                paramSearch.image_analytics_types = [];
                paramSearch.topicsObject = topicsObject;

                dispatch(fetchChartDataWithSearchApi(paramSearch));

                let param = {
                    filter: {
                        own: {},
                        competitor: {},
                    },
                };
                param.topic_name = "own";
                param.chart_name = "brand-comparision";
                param["recommendation_types"] = ["brand_comparision"];

                if (brandTopicObj) {
                    let params1 = getSearchParams({ topic_data: brandTopicObj, filter: brandFilters });
                    params1.image_analytics_types = [];
                    param.filter.own = JSON.parse(JSON.stringify(params1));
                }

                if (competitorTopicObj) {
                    let params = getSearchParams({ topic_data: competitorTopicObj, filter: competitorFilters });
                    params.image_analytics_types = [];
                    param.filter.competitor = JSON.parse(JSON.stringify(params));
                }
                dispatch(fetchRecommendationLists(param, "brand_comparision", 0));
                break;
            }

            default:
                break;
        }
    };

    const getSearchParams = ({ topic_data, filter }) => {
        let { location, platform, language } = filter;

        let params = {
            location,
            platform,
            language,
        };
        let tz = JSON.parse(localStorage.company).user_timezone_name;

        // params.location = countries.map((country) => country.id);
        // params.platform = platforms.map((plt) => plt.id);
        // params.language = languages.map((lg) => lg.id);

        params.start_date = moment().tz(tz).subtract(7, "days").startOf("day").format("YYYY-MM-DDTHH:mm:ss");
        params.end_date = moment().tz(tz).subtract(1, "days").endOf("day").format("YYYY-MM-DDTHH:mm:ss");
        params.apply_exclusion = "yes";
        let formattedTopic = getFormattedTopic(topic_data);
        params.topic_data = [formattedTopic];

        return params;
    };
    let Component = componentObj[pageHeading];
    let question = QuestionLists.find((obj) => obj.questionTab === pageHeading)?.question || "";
    return (
        <div className="insights__home__page">
            <div className="top__section">
                <div className="heading__block">
                    <div className="right__section">
                        <div className="insights__heading question__container">{question}</div>
                        <ArrowIcon className=" back__icon right__arrow" onClick={handleClick} />
                    </div>
                </div>
            </div>

            <div className="main__content__wrapper">
                <Scrollbars autoHide>
                    {notConfigured ? (
                        <div className="not__configured">
                            <EmptyPage gptNoData={pageHeading} />
                        </div>
                    ) : (
                        <Component />
                    )}
                </Scrollbars>
            </div>
        </div>
    );
};

export default ChartPageContainer;

const getFormattedTopic = (topicObj) => {
    let subtopicIds;
    let topic_id;
    let name;
    let subtopicNames;

    if (topicObj?.length > 0) {
        subtopicIds = topicObj[0]?.subtopicNames.map((subTopic) => subTopic.id);
        topic_id = topicObj[0]?.topic_id;
        name = topicObj[0]?.name;
        subtopicNames = topicObj[0].subtopicNames.map((subTopic) => {
            let subId = subTopic.id;
            let subName = subTopic.name;
            return {
                id: subId,
                name: subName,
            };
        });
    } else {
        topic_id = topicObj?.id;
        name = topicObj?.name;
        subtopicIds = topicObj?.subtopics?.map((subTopic) => subTopic.subtopic_id);

        subtopicNames = topicObj?.subtopics?.map((subTopic) => {
            let subId = subTopic.subtopic_id;
            let subName = subTopic?.subtopic_name;
            return {
                id: subId,
                name: subName,
            };
        });
    }

    return {
        topic_id: topic_id,
        name: name,
        subtopicIds,
        subtopicNames,
    };
};
